/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для персональных рекомендаций на странице поиска
   */
  app.PersonalRecommendationsSearchView = app.PersonalRecommendationsView.extend({
    searchQuery: '',
    /**
     * @inheritDoc
     */
    run: function () {
      app.PersonalRecommendationsView.prototype.run.apply(this);
      this.listenTo(Backbone, 'pushOkoForRecommendations', this.updateRecommendation);
    },

    /**
     * Обновление рекомендаций в поиске
     * @param {number} timeStamp Для формирования запроса к апи.
     * @param {string} searchQuery Поисковый запрос пользователя.
     * @param {boolean} needSimilarItems нужны похожие товары для товара не на складе.
     */
    updateRecommendation: function (timeStamp, searchQuery, needSimilarItems) {
      if (!searchQuery) {
        this.$('.owl-nav').remove();
        this.$('.recommendations-widgettitle').text('Обратите внимание');
      }
      this.model.restoreDefaultRequestParameters();
      // Условие для вывода блока рекомендаций "искавшие 'товар' также смотрели"
      if (!app.isProd && app.helpers.CookieHelper.getCookie('is_search_recommend_local')) {
        this.model.requestParameters['timestamp'] = 1;
      } else {
        this.model.requestParameters['timestamp'] = timeStamp;
      }
      this.searchQuery = _.escape(searchQuery);
      if (needSimilarItems) {
        this.title = 'Аналогичные товары в наличии';
        this.model.requestParameters = {
          product_sid: this.searchQuery,
          type: app.CACHE_TYPE_RELATED_LIST,
        };
      }
      this.model.fetch();
      if (this.search && !this.search.state.totalRecords && !app.isMobile) {
        this.withoutCarousel = true;
        this.$el.addClass("without-carousel");
      } else {
        this.withoutCarousel = false;
        this.$el.removeClass("without-carousel");
      }
    },

    /**
     * @inheritDoc
     */
    getTitle: function () {
        var meta = this.model.get('_meta');
        if (meta.hasOwnProperty('blockTitle')) {
          //Из апи приходит строка вида "искавшие {q} так же смотрели", меняем {q} на запрос пользователя
          return meta.blockTitle.replace('{q}', this.searchQuery);
        } else {
          return this.title;
        }
    }
  });
})();

}.call(window));